import React, { useEffect } from 'react';
import { useI18n } from '@alife/panda-i18n';
import { event } from '@ice/stark-data';
import { CnMessage, CnTextEllipsis } from '@alife/cn-ui';
// @ts-ignore
import { logCustom } from 'src/utils/tracker';
import { PanelType } from 'src/types';
import { getWordOrderUrl } from '../../../feedback';
import { REFRESH_ALL_KEY } from 'src/utils/const';
import { focusOrCancelHotFeedback } from 'src/services';
import './index.scss';
export default function HotFeedback(props) {
    const { panelCode, list, linkCode, env } = props;
    const $i18n = useI18n();
    useEffect(() => {
        if (list?.length) {
            logCustom(`EXP_${PanelType.hotFeedback}`, { linkCode }, panelCode);
        }
    }, []);
    if (!list?.length)
        return null;
    return (React.createElement("div", { className: 'cn-intelli-assistant-hot-feedback' },
        React.createElement("div", { className: 'cn-intelli-assistant-hot-feedback-title' },
            $i18n.get({
                id: 'HotFeedback',
                dm: '热门反馈',
            }),
            React.createElement("span", { className: "cn-intelli-assistant-hot-feedback-title-right", onClick: () => {
                    const detailUrl = `${getWordOrderUrl({
                        env: env || 'prod',
                        userSystem: props.userSystem,
                        linkCode,
                        path: '/hot-feedback',
                    })}`;
                    window.open(detailUrl);
                    logCustom(`CLK_${PanelType.hotFeedback}ViewMore`, {
                        linkCode,
                    }, panelCode);
                } }, $i18n.get({
                id: 'ViewMore',
                dm: '查看更多',
            }))),
        list?.map((it, i) => {
            return (React.createElement("div", { className: 'cn-intelli-assistant-hot-feedback-item', key: it?.id, onClick: () => {
                    const detailUrl = `${getWordOrderUrl({
                        env: env || 'prod',
                        userSystem: props.userSystem,
                        linkCode,
                        path: '/feedback-detail',
                    })}&id=${it.id}`;
                    window.open(detailUrl);
                    logCustom(`CLK_${PanelType.hotFeedback}Item`, {
                        id: it.id,
                        linkCode,
                    }, panelCode);
                } },
                React.createElement("span", { className: 'cn-intelli-assistant-hot-feedback-item-left' }, i + 1),
                React.createElement("div", { className: 'cn-intelli-assistant-hot-feedback-item-content' },
                    React.createElement(CnTextEllipsis, { line: 1 }, it?.title)),
                React.createElement("div", { className: 'cn-intelli-assistant-hot-feedback-item-right', onClick: async (e) => {
                        e.stopPropagation();
                        await focusOrCancelHotFeedback({
                            hotFeedbackID: it.id,
                            liked: !it.liked,
                            userId: props.config?.userId,
                            accountType: props.userSystem,
                        });
                        CnMessage.success($i18n.get({
                            id: 'OperationSuccessful',
                            dm: '操作成功',
                        }));
                        event.emit(REFRESH_ALL_KEY);
                    } },
                    React.createElement(React.Fragment, null,
                        React.createElement("img", { className: 'cn-intelli-assistant-hot-feedback-item-right-img', src: it.liked ? 'https://gw.alicdn.com/imgextra/i1/O1CN01P7WGlw1HMnXSWkXEy_!!6000000000744-55-tps-20-20.svg' : 'https://gw.alicdn.com/imgextra/i1/O1CN012NI3iM1KIANfMMIKr_!!6000000001140-55-tps-20-20.svg', alt: "" }),
                        React.createElement("span", { className: 'cn-intelli-assistant-hot-feedback-item-right-count' }, it.heat > 99 ? '99+' : it.heat)))));
        })));
}
